import { type FunctionComponent, type MouseEvent } from 'react';
import classnames from 'classnames';
import { getLinks } from './getLinks.ts';
import { PageLinksItem } from './PageLinksItem.tsx';

import styles from './styles/main.scss';

type PageLinksProps = {
    numberOfPages: number;
    currentPage: number;
    onPageChange: (args: { e: MouseEvent<HTMLElement>; pageNumber: number }) => void;
    getPageLinkUrl?: (pageNumber: number) => string;
    totalPageLinks?: number;
    showNumbers?: boolean;
    noUnderline?: boolean;
    align?: 'left' | 'center';
};

export const PageLinks: FunctionComponent<PageLinksProps> = ({
    currentPage,
    numberOfPages,
    onPageChange,
    getPageLinkUrl,
    totalPageLinks = 6,
    showNumbers = true,
    noUnderline,
    align = 'center',
}) => {
    if (numberOfPages <= 1) {
        return null;
    }

    const generatedPageLinks = getLinks({
        numberOfPages,
        currentPage,
        totalPageLinks,
        showNumbers,
    });

    return (
        <ul
            className={classnames(styles.pageLinkList, {
                [styles.alignLeft]: align === 'left',
            })}
            data-tp={numberOfPages}
            data-tn="pageLink-list"
        >
            {generatedPageLinks.map(({ type, key, pageNumber, isSelected }) => (
                <li
                    key={key}
                    className={classnames(styles.pageLinkItem, {
                        [styles.arrowWrapperPrev]: type === 'BACK',
                        [styles.arrowWrapperNext]: type === 'FORWARD',
                        [styles.arrowWrapper]: ['BACK', 'FORWARD'].includes(type),
                    })}
                >
                    <PageLinksItem
                        type={type}
                        numberOfPages={numberOfPages}
                        pageNumber={pageNumber}
                        isSelected={isSelected}
                        currentPage={currentPage}
                        onLinkClick={onPageChange}
                        getPageLinkUrl={getPageLinkUrl}
                        noUnderline={noUnderline}
                    />
                </li>
            ))}
        </ul>
    );
};
